import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "filterable-list__list-item-meta-date" };
import { computed } from 'vue';
import { useI18n, useConfig } from '../features';
import { formatDate } from "../services/date-mapper";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NewsListItemContentDate',
    props: {
        item: {}
    },
    setup(__props) {
        const { item } = __props;
        const { thema } = useConfig();
        const { getLocale } = useI18n();
        const locale = getLocale();
        const isDateEndVisible = computed(() => {
            return item?.dateEnd &&
                item?.dateEnd !== undefined &&
                formatDate(item?.date, locale) !== formatDate(item?.dateEnd, locale) &&
                thema &&
                thema.value === 'events';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createTextVNode(_toDisplayString(_unref(formatDate)(_ctx.item?.date, _unref(locale))) + " ", 1 /* TEXT */),
                (isDateEndVisible.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("  –  " + _toDisplayString(_unref(formatDate)(_ctx.item?.dateEnd, _unref(locale))) + _toDisplayString(' '), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
